import React from 'react'
import "./Footer.css"

const Footer = () => {
  return (
    <div className='Footer'>
        <footer className='page-footer font-small cyan darken-3'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 py-4'>
                        <div className='flex-center'>
                            <a class="li-ic" href='https://www.linkedin.com/in/kalyan-g-45391b217/'>
                            <i class="fab fa-linkedin-in fa-lg white-text mr-md-5 mr-3 fa-2x"> </i>
                            </a>
                            <a class="ins-ic" href='https://t.me/KalyanG_Bot'>
                            <i class="fab fa-telegram fa-lg white-text mr-md-5 mr-3 fa-2x"></i>
                            </a>
                            <a class="tw-ic" href='https://x.com/ReverentPioneer?t=QwO9hF1RqOzj8FZ5KA-qHg&s=08'>
                            <i class="fab fa-twitter fa-lg white-text mr-md-5 mr-3 fa-2x"> </i>
                            </a>
                            <a class="fb-ic" href='https://www.facebook.com/KalyanGopu.gk?mibextid=ZbWKwL'>
                            <i class="fab fa-facebook-f fa-lg white-text mr-md-5 mr-3 fa-2x"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-copyright text-center py-3">© 2023 Copyright : Kalyan Gopu
  </div>
        </footer>
    </div>
  )
}

export default Footer
